import { useMemo } from "react";
import { RentRollItem } from "../../types/contract";

export const useRentRollFilter = (
  rentRollData: RentRollItem[],
  rentRollPropertyFilter: string,
  rentRollRoomFilter: string,
  rentRollLesseeFilter: string
) => {
  // フィルタリングされたレントロールデータ
  const filteredRentRollData = useMemo(() => {
    const lowerCaseProperty = rentRollPropertyFilter.toLowerCase();
    const lowerCaseRoom = rentRollRoomFilter.toLowerCase();
    const lowerCaseLessee = rentRollLesseeFilter.toLowerCase();

    return rentRollData.filter(
      (item) =>
        (item.property_name || "").toLowerCase().includes(lowerCaseProperty) &&
        (item.room_name || "").toLowerCase().includes(lowerCaseRoom) &&
        (item.lessee_name || "").toLowerCase().includes(lowerCaseLessee)
    );
  }, [
    rentRollData,
    rentRollPropertyFilter,
    rentRollRoomFilter,
    rentRollLesseeFilter,
  ]);

  // フィルターオプション
  const propertyOptions = useMemo(
    () =>
      [...new Set(rentRollData.map((item) => item.property_name || ""))]
        .filter(Boolean)
        .sort(),
    [rentRollData]
  );

  const roomOptions = useMemo(
    () =>
      [...new Set(rentRollData.map((item) => item.room_name || ""))]
        .filter(Boolean)
        .sort(),
    [rentRollData]
  );

  const lesseeOptions = useMemo(
    () =>
      [...new Set(rentRollData.map((item) => item.lessee_name || ""))]
        .filter(Boolean)
        .sort(),
    [rentRollData]
  );

  return {
    filteredRentRollData,
    propertyOptions,
    roomOptions,
    lesseeOptions,
  };
};